import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import ToggleTheme from "./ToggleTheme";
import Aos from "aos";
import "aos/dist/aos.css";
import ToggleLang from "./ToggleLang";
import { useContext } from "react";
import { defaultLang } from "./LanguageContext";

export default function Navbar() {
  const [showMenu, setShowMenu] = useState(true);
  let menuRef = useRef();

  const { lang } = useContext(defaultLang);
  useEffect(() => {
    function closeMenu(e) {
      if (!menuRef.current?.contains(e.target)) {
        setShowMenu(true);
      }
    }
    document.addEventListener("mousedown", closeMenu);
    console.log(
      "%c Welcome to my domain 🕶️🩻🕵️‍♀️",
      "color:#9499ff; font-weight:bolder; font-size:1.5rem;"
    );
  });

  useEffect(() => {
    Aos.init({
      duration: 500,
    });
  }, []);

  return (
    <nav className='flex justify-between  mx-3 pt-7 md:mx-20 lg:mx-36 xl:mx-48 '>
      <div className='lg:hidden mt-1'>
        <button
          onClick={() => {
            setShowMenu(!showMenu);
          }}>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            aria-hidden='true'
            focusable='false'
            viewBox='0 0 24 24'
            data-v-d03bf763=''
            className='w-12 h-12 scale-[.8] sm:scale-[1] fill-[#E3E3E3] dark:fill-[#1E1E1E]'>
            <path d='M17,11H3c-0.6,0-1-0.4-1-1s0.4-1,1-1h14c0.6,0,1,0.4,1,1S17.6,11,17,11z' />
            <path d='M21,7H3C2.4,7,2,6.6,2,6s0.4-1,1-1h18c0.6,0,1,0.4,1,1S21.6,7,21,7z' />
            <path d='M21,15H3c-0.6,0-1-0.4-1-1s0.4-1,1-1h18c0.6,0,1,0.4,1,1S21.6,15,21,15z' />
            <path d='M17,19H3c-0.6,0-1-0.4-1-1s0.4-1,1-1h14c0.6,0,1,0.4,1,1S17.6,19,17,19z' />
          </svg>
        </button>
      </div>

      {!showMenu && (
        <div
          data-aos='fade-right'
          className='absolute no-scroll rounded-r-2xl bg-[#1E1E1E] dark:bg-gray-100  w-[70vw] h-[100vh] top-0 left-0  text-[#E3E3E3] flex flex-col gap-24 z-50  justify-start font-bold'
          ref={menuRef}>
          <div className='mt-12 mx-16  lg:mt-5 flex justify-between'>
            <div></div>
            <div className=''>
              <button
                onClick={() => {
                  setShowMenu(true);
                }}
                type='button'
                className='absolute top-12 right-2.5 text-[#E3E3E3] bg-transparent transition-all duration-500 hover:bg-[#51539cc7] rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-[#9499ff] dark:hover:text-white'
                data-modal-toggle='popup-modal'>
                <svg
                  aria-hidden='true'
                  className='w-6 h-6 fill-[#E3E3E3]  dark:fill-[#1E1E1E]'
                  viewBox='0 0 20 20'
                  xmlns='http://www.w3.org/2000/svg'>
                  <path
                    fillRule='evenodd'
                    d='M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z'
                    clipRule='evenodd'></path>
                </svg>
                <span className='sr-only'>Close modal</span>
              </button>
            </div>
          </div>

          <ul
            className='flex flex-col justify-center items-center mx-16 space-y-8 
           text-left tracking-wider uppercase'>
            <li>
              <Link
                onClick={() => {
                  setShowMenu(true);
                }}
                className=' text-xl transition-all dark:text-[#1E1E1E] dark:font-bold ahover hover:text-[#9499ff]'
                to='/projects'>
                {lang === "Eng" ? "Projects" : "Progetti"}
              </Link>
            </li>
            <li>
              <a
                target='_blank'
                rel='noreferrer'
                className=' text-xl transition-all dark:text-[#1E1E1E] dark:font-bold ahover  hover:text-[#9499ff]'
                href='https://github.com/d2ni3l/'>
                GitHub
              </a>
            </li>
            <li>
              <Link
                onClick={() => {
                  setShowMenu(true);
                }}
                className=' text-xl transition-all dark:text-[#1E1E1E] dark:font-bold ahover hover:text-[#9499ff]'
                to='/contact'>
                {lang === "Eng" ? "Contacts" : "Contatti"}
              </Link>
            </li>
            <li>
              <Link
                onClick={() => {
                  setShowMenu(true);
                }}
                className=' text-xl transition-all dark:text-[#1E1E1E] dark:font-bold ahover hover:text-[#9499ff]'
                to='/about'>
                {lang === "Eng" ? "About" : "Info personali"}
              </Link>
            </li>
          </ul>
        </div>
      )}

      <div className='mt-4 sm:mt-3 md:mt-5 lg:mt-5'>
        <Link to='/'>
          <h1 className='text-[#E3E3E3] text-xl  dark:text-[#1E1E1E] dark:font-bold  font-bold sm:text-2xl font-mono flex flex-row gap-1'>
            <span>Daniel </span>
            <span className='text-[#9499FF] flex font-black  gap-1'>
              Johnson{" "}
              <span>
                <img
                  className='w-9 h-9'
                  src='https://freesvg.org/img/1547600312.png'
                  alt=''
                />
              </span>
            </span>
          </h1>
        </Link>
      </div>

      <div className='text-[#E3E3E3]  font-semibold mt-[1.6rem]  hidden lg:block md:mr-24'>
        <ul className='flex space-x-6 tracking-widest md:text-lg lg:text-lg'>
          <li className=''>
            <Link
              className='hover:text-[#9499ff] ahover focus:text-[#9499ff] transition-all dark:text-[#1E1E1E] dark:font-bold '
              to='/projects'>
              {lang === "Eng" ? "Projects" : "Progetti"}
            </Link>
          </li>

          <li>
            <Link
              className='hover:text-[#9499ff] ahover focus:text-[#9499ff] dark:text-[#1E1E1E] dark:font-bold transition-all  '
              to='/contact'>
              {lang === "Eng" ? "Contacts" : "Contatti"}
            </Link>
          </li>
          <li>
            <Link
              className='hover:text-[#9499ff] ahover focus:text-[#9499ff] dark:text-[#1E1E1E] dark:font-bold transition-all  '
              to='/about'>
              {lang === "Eng" ? "About" : "Info personali"}
            </Link>
          </li>
          <li>
            <a
              target='_blank'
              rel='noreferrer'
              className='hover:text-[#9499ff] ahover dark:text-[#1E1E1E] dark:font-bold focus:text-[#9499ff] transition-all  '
              href='https://github.com/d2ni3l/'>
              GitHub
            </a>
          </li>
        </ul>
      </div>

      <div className='flex gap-3 toggle mt-[.7rem] scale-[.8] sm:scale-[1] md:mt-[1.36rem] items-center'>
        <ToggleTheme />
        <ToggleLang />
      </div>
    </nav>
  );
}
